import { register } from 'register-service-worker';
// Source: https://redfin.engineering/service-workers-break-the-browsers-refresh-button-by-default-here-s-why-56f9417694
// Source: https://redfin.engineering/how-to-fix-the-refresh-button-when-using-service-workers-a8e27af6df68
if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            //
        },
        registered(registration) {
            console.log('Service worker has been registered.');
            setInterval(() => {
                registration.update();
            }, 1000 // millis
                * 15);
        },
        cached() {
            console.log('Content has been cached for offline use.');
        },
        updatefound(registration) {
            console.log('New content is downloading.');
            // This should be in updated(), but the script doesn't go there, probably a version-diffing issue, which might be hard to solve
            // Since this is in 'updateFound' this fires before all files are deployed/loaded on the server, therefore we use a timeout that for sure runs after deploy
            setTimeout(() => {
                const event = new CustomEvent('swUpdated', { detail: registration });
                document.dispatchEvent(event);
            }, 1000 // millis
                * 60 // seconds
                * 2);
        },
        updated() {
            console.log('New content is available; please refresh.');
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.');
        },
        error(error) {
            console.error('Error during service worker registration:', error);
        },
    });
}
